import React, { Component } from 'react';
import Helmet from 'react-helmet';
import { Link } from 'react-router-dom';

import { smoothScroll } from '../../helpers/view';
import SheetTitle from '../../components/SheetTitle';
import c from './TermsOfUse.less';

export default class TermsOfUseComponent extends Component {
  componentDidMount() {
    smoothScroll();
  }

  render() {
    return (
      <div className={c.container}>
        <Helmet defer={false}>
          <title>Terms of Use at Mp3Caprice</title>
          <meta name="description" content="Discover, buy and download high quality tunes for reasonable prices." />
          <meta property="mc:dp" content="/shop/terms-of-use" />
          <meta property="mc:page" content="Terms" />
        </Helmet>
        <SheetTitle title="Terms of use" />
        <div className={c.termsContainer}>
          <p>
            This Agreement represents agreement between the administration of the website at mp3caprice.com
            (hereinafter the Administration) and the user of the website at mp3caprice.com (hereinafter the User) and governs the
            procedure of provision of services to the User at the Website.
          </p>
          <h3>1. Main Provisions</h3>
          <p>1.1. By registering at the Website the User agrees to all provisions hereof.</p>
          <p>
            1.2. Ignorance of provisions of this Agreement shall not relieve the User of liability for violation hereof.
          </p>
          <p>
            1.3. The Administration reserves the right to amend this Agreement without prior approval of the User. The
            User shall at least once a month review the substance of this Agreement as posted on the Website. If any
            significant amendment is made to the Agreement you will be given notice by email. If you should disagree
            with at least one paragraph hereof you shall cease your registration at our Website. By further using our
            services after you receive notice of amendment you acknowledge your acceptance of such an amendment.
          </p>
          <p>
            1.4. This Agreement is effective throughout the period of the User&apos;s registration at the Website and
            use of materials and intellectual property items downloaded by the User from the Website.
          </p>
          <p>
            1.5. The User shall address all issues related to use of the Website&apos;s services to
            the <Link to="/shop/contact">Administration&apos;s Technical Support</Link>.
          </p>
          <h3>2. Registration Rules</h3>
          <p>
            2.1. The User shall provide true and accurate personal information during registration so that services can
            be provided to them in a complete and high-quality manner.
          </p>
          <p>
            2.2. During registration the User receives unique details (such as login and password) that the User needs
            to access their account. The User shall keep these data in a secure place to prevent a third party&apos;s
            access to the account.
          </p>
          <p>2.3. The Administration and the User shall maintain confidentiality of information submitted. The
            Administration shall not deliver the User&apos;s personal data to any third parties. Respectively, the User
            shall not deliver their account access data, such as the User&apos;s login and password, to any third parties. The
            User shall be liable for damage caused by the registered User&apos;s delivery of their mp3caprice.com access data
            to any third parties.
          </p>
          <h3>3. Services</h3>
          <p>
            3.1. The main paid service provided to the Website&apos;s users is legal download by the User of music
            titles,
            soundtracks and albums (hereinafter the Content).
          </p>
          <p>3.2. The price of each Content item is shown on the Website.</p>
          <p>
            3.3. Download can be paid by advance payment through any means available to the User (such as Visa, MasterCard or PayPal).
          </p>
          <h3>4. Payment</h3>
          <p>
            4.1. Advance payment made by the User is followed by a proportionate increase of the User&apos;s balance at
            the Website.
          </p>
          <p>
            4.2. A Content unit downloaded by the User is followed by a deduction from the User&apos;s balance at the Website.
          </p>
          <p>
            4.3. As a means of obtaining information about the Content the User is entitled to preliminary listening
            to/viewing of a 30-second Content item in a format adapted to web listening/viewing (low bitrate).
          </p>
          <h3>5. Procedure of Provision and Terms of Use of Files</h3>
          <p>
            5.1. We do not guarantee that your equipment (such as the computer, software, connection etc) will be
            suitable for work with our Website. You are alone responsible for ensuring compatibility of your equipment with our
            service.
          </p>
          <p>
            5.2. We reserve the right to temporarily or permanently change or discontinue specific services at any
            time. Some currently available files may become unavailable. We reserve the right to change the catalog at any
            time without prior notice.
          </p>
          <p>
            5.3. The title the User purchases is added to the download section where it can be downloaded from. It will
            be available for download without expiration.
          </p>
          <p>5.4. We reserve the right to revise the policy of availability of purchased titles for download.</p>
          <h3>6. Bonuses and discounts</h3>
          <p>6.1. Bonus money is not subject to refund.</p>
          <h3>7. Returns and Refunds</h3>
          <p>7.1. The Content may be returned within 30 days after the balance is topped up.</p>
          <p>
            7.2. If the tracks you have downloaded have defects, low quality or fail to correspond to their description
            you may apply to us for a refund. You may receive a refund only after consulting the Administration on
            possible ways of resolving the issue. First of all, we may suggest that your find a relevant product of
            desirable quality or have it replaced with a different one. The amount can only be refunded to the account
            balance.
          </p>
          <p>
            7.3. You may request a refund if less than 5% of your balance has been used and you are not satisfied with
            service quality. That you have purchased several tracks and cannot find anything else of interest may not
            serve as the grounds for a refund. We strongly recommend that you use the shopping cart to estimate the
            amount you need for payment before refilling your balance.
          </p>
          <h3>8. Exchange difference and currencies</h3>
          <p>
            8.1. All prices are represented in US dollars solely for informative purposes and user convenience.
          </p>
          <p>
            8.2. When user refills the account, the money from user&apos;s card is withdrawn in the currency of the
            Service
            location country and the resulting sum can slightly differ from the declared one and depends on the current
            exchange rate of the payment system (e.g. Visa or MasterCard).
          </p>
          <p>
            8.3. In the event of refund (see 7.) the money returned to user is represented in the currency of the
            Service location country. The resulting sum charged back to user&apos;s card can slightly differ from the sum on
            user&apos;s Balance account represented in US dollars and depends on the current exchange rate of the payment system
            (e.g. Visa or MasterCard).
          </p>
          <h3>9. Legal Aspects</h3>
          <p>
            9.1. All titles and soundtracks are posted on the mp3caprice.com Website under relevant agreements with
            entities involved with collective management of copyright and related rights.
          </p>
          <p>9.2. Our service is intended for personal use only. Any commercial use or further distribution of files
            downloaded from the Website is prohibited.
          </p>
          <p>9.3. The Website&apos;s Administration is not in the position to monitor lawfulness of use of this service
            in every country this service is available in. We do not provide any consultation services on this matter to the
            User, either.
          </p>
          <p>
            9.4. The User shall bear complete liability for compliance with laws of the User&apos;s country of
            residence during use of the Website&apos;s services.
          </p>
        </div>
      </div>
    );
  }
}
